import { Box, Button, Stack } from "@mui/material";
import { Link, Outlet } from "react-router";
import { Pages } from "../../utils";
import WestIcon from "@mui/icons-material/West";
import { Body1Typography } from "../../components/typography";

export const AddDesignerFilePage = () => {
  return (
    <Box>
      {/* Removed the Stack container - now handled by individual pages */}

      <Outlet />
    </Box>
  );
};
